var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldAcquireAccessToken = exports.handleAuthSite401Response = exports.getNewAccessToken = exports.getAccessToken = exports.getSavedToken = exports.saveToken = exports.TOKEN_KEY = exports.TOKEN_INPUT_ID = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const convertToContextUri_1 = __importDefault(require("./convertToContextUri"));
const isDevServer_1 = __importDefault(require("./isDevServer"));
const isDevelopment_1 = __importDefault(require("./isDevelopment"));
const toasty_1 = require("./toasty");
exports.TOKEN_INPUT_ID = '__accessToken';
exports.TOKEN_KEY = 'HendersonAccessToken';
function saveToken(token) {
    localStorage.setItem(exports.TOKEN_KEY, token);
}
exports.saveToken = saveToken;
function getSavedToken() {
    return localStorage.getItem(exports.TOKEN_KEY);
}
exports.getSavedToken = getSavedToken;
function getAccessToken() {
    if (shouldAcquireAccessToken()) {
        return getTokenFromInput() || getSavedToken();
    }
    return '';
}
exports.getAccessToken = getAccessToken;
function getTokenFromInput() {
    const el = document.getElementById(exports.TOKEN_INPUT_ID);
    if (el && el.value) {
        const token = el.value;
        saveToken(token);
        el.value = '';
        return token;
    }
    return null;
}
function getNewAccessToken(forceRefresh = false) {
    return fetch((0, convertToContextUri_1.default)('https://auth.hendersonengineers.com/API/Token?forceRefresh=' + forceRefresh), getFetchOptions()).then(async (r) => {
        if (r.ok)
            return r.json();
        throw new Error(await r.text());
    });
}
exports.getNewAccessToken = getNewAccessToken;
function getFetchOptions() {
    const headers = new Headers();
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');
    const usernameHashInput = document.getElementById('__UsernameHash');
    if (usernameHashInput) {
        headers.set('User', usernameHashInput.value);
    }
    return {
        method: 'GET',
        headers: headers,
        credentials: 'include'
    };
}
function handleAuthSite401Response() {
    // On localhost specifically, we can't check for the FormsMetadata cookie to know if the user should be acquiring access tokens.
    // So instead, we need to make a quick API call to check that.
    if ((0, isDevServer_1.default)()) {
        fetch((0, convertToContextUri_1.default)('https://inet.hendersonengineers.com/Home/API/ShouldUseAccessTokens'), getFetchOptions())
            .then(async (r) => {
            if (!r.ok || (await r.json())) {
                showSessionExpiredMessage();
            }
        })
            .catch(e => {
            showSessionExpiredMessage();
        });
    }
    else {
        // If it's not localhost, we can just check for the FormsMetadata cookie.
        if (shouldAcquireAccessToken()) {
            showSessionExpiredMessage();
        }
    }
}
exports.handleAuthSite401Response = handleAuthSite401Response;
function showSessionExpiredMessage() {
    (0, toasty_1.error)('Your session has expired. Please refresh the page to continue', {
        id: 'sessionExpiredToasty',
        manuallyHide: true
    });
}
function shouldAcquireAccessToken() {
    return !js_cookie_1.default.get((0, isDevelopment_1.default)() ? '.HendersonDevFormsMetadata' : '.HendersonFormsMetadata');
}
exports.shouldAcquireAccessToken = shouldAcquireAccessToken;
//# sourceMappingURL=tokenAuth.js.map